import React, { useState } from 'react'

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleIcon,
  CollapsibleTrigger,
} from '@wartek-id/collapsible-v1'
import { Text } from '@wartek-id/text-v1'

type AccordionProps = {
  className?: string
  data: {
    label: string
    value: string
  }[]
}

const Accordion = ({ className, data }: AccordionProps) => {
  const [showed, setShowed] = useState<number>(-1)
  return (
    <div className={className}>
      {data.map(({ label, value }, index) => (
        <Collapsible
          key={index}
          open={showed === index}
          onToggle={(open) => {
            setShowed(() => {
              if (open) return index
              return -1
            })
          }}
          variant="card"
        >
          <CollapsibleTrigger>
            <Text variant="body-bold">{label}</Text>
            <CollapsibleIcon />
          </CollapsibleTrigger>
          <CollapsibleContent>
            <div className="p-4">
              <Text color="subdued">{value}</Text>
            </div>
          </CollapsibleContent>
        </Collapsible>
      ))}
    </div>
  )
}

export default Accordion
